import firebase from "firebase";
import "firebase/firestore";

var config = {
  apiKey: "AIzaSyC1HFvypVeTpDeD_L8ie21Fh3uUCAYIT9w",
  authDomain: "journey-dev-e791c.firebaseapp.com",
  databaseURL: "https://journey-dev-e791c.firebaseio.com",
  projectId: "journey-dev-e791c",
  storageBucket: "journey-dev-e791c.appspot.com",
  messagingSenderId: "218517079432",
  appId: "1:218517079432:web:9e36f8d45386270bb5a63d"
};

firebase.initializeApp(config);

// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
// const googleProvider = new firebase.auth.GoogleAuthProvider();
// const facebookProvider = new firebase.auth.FacebookAuthProvider();
const currentUser = auth.currentUser;
const storage = firebase.storage();
const functions = firebase.functions();
const fieldValue = firebase.functions.FieldValue;

// date issue fix according to firebase
const settings = {};
db.settings(settings);

// firebase collections

export default {
  db,
  auth,
  functions,
  currentUser,
  fieldValue,
  storage
  // googleProvider,
  // facebookProvider,
};
